"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const numberClass_1 = require("./numberClass");
const stringClass_1 = require("./stringClass");
const booleanClass_1 = require("./booleanClass");
exports.Classes = {
    NumberLiteral: numberClass_1.NumberClass,
    StringLiteral: stringClass_1.StringClass,
    BooleanLiteral: booleanClass_1.BooleanClass,
};
